import Image from '@/components/Image';
import React from 'react';

const KLARNA_LOGO_STYLE: React.CSSProperties = { height: 'max(.8333333333vw, 12px)' };

export function KlarnaLogo({
  className,
  style,
  width = 50,
  height = 12,
}: {
  className?: string;
  style?: React.CSSProperties;
  width?: number;
  height?: number;
}) {
  return (
    <Image
      src="/goods-detail/klarna.png"
      alt="klarna payment"
      width={width}
      height={height}
      style={style ?? KLARNA_LOGO_STYLE}
      className={className ?? 'w-auto align-middle'}
    />
  );
}

export const renderTextWithKlarnaLogo = (
  text: string,
  options?: { className?: string; style?: React.CSSProperties },
) =>
  text.split('Klarna').map((part, index, arr) => (
    <React.Fragment key={index}>
      {part}
      {index < arr.length - 1 && (
        <KlarnaLogo
          style={options?.style}
          className={options?.className ?? 'w-auto align-middle inline ml-[2pt] mr-1'}
        />
      )}
    </React.Fragment>
  ));

export interface ColorHighlight {
  match: string | RegExp;
  color: string;
}

/** 将 string | RegExp 统一转为 regex source，string 会自动转义特殊字符 */
function toSource(m: string | RegExp): string {
  return typeof m === 'string' ? m.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') : m.source;
}

/**
 * 渲染 Klarna 促销文本：
 * - `Klarna` → KlarnaLogo 图标
 * - highlights 中每条规则匹配的片段 → 对应颜色
 *
 * @example
 * renderKlarnaPromotionText(text, [
 *   { match: '$15 off', color: '#E02020' },
 *   { match: /\$\d+\+?/, color: '#E02020' },
 * ])
 */
export function renderKlarnaPromotionText(text: string, highlights: ColorHighlight[] = []) {
  const allPatterns = ['Klarna', ...highlights.map((h) => toSource(h.match))];
  const splitRegex = new RegExp(`(${allPatterns.join('|')})`);

  return text.split(splitRegex).map((part, index) => {
    if (part === 'Klarna') {
      return <KlarnaLogo key={index} className="inline ml-[2pt] mr-1 w-auto align-middle" />;
    }
    const hit = highlights.find((h) =>
      typeof h.match === 'string' ? h.match === part : h.match.test(part),
    );
    if (hit) {
      return (
        <span key={index} style={{ color: hit.color }}>
          {part}
        </span>
      );
    }
    return <React.Fragment key={index}>{part}</React.Fragment>;
  });
}
